export const routerPaths = {
  ROOT: "/",
  INFO: "/info",
  API_DOCS: "/api-docs",
  MODEL_DIRECTORY: "/modeldirectory",
  EXPLORER: "/explorer",
  EXPLORER_OCCUPATIONS: "/explorer/:modelId/occupations",
  EXPLORER_OCCUPATIONS_DETAIL: "/explorer/:modelId/occupations/:occupationId",
  EXPLORER_SKILLS: "/explorer/:modelId/skills",
  EXPLORER_SKILLS_DETAIL: "/explorer/:modelId/skills/:skillId",
};
